// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
}

.transactions-page {
  padding: 2px 0 8px;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
}

.page-header h1 {
  margin: 0;
  color: #172b46;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
}

.page-header p {
  margin: 6px 0 0;
  color: #7d8a9d;
  font-size: 12px;
}

.header-actions,
.filter-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 35px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  padding: 7px 12px;
  background: #fff;
  color: #53647a;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.button .material-symbols-outlined {
  font-size: 18px;
}

.button:hover,
.button.selected {
  border-color: color-mix(in srgb, var(--primary-color) 25%, white);
  background: color-mix(in srgb, var(--primary-color) 5%, white);
  color: var(--primary-color);
}

.button.primary {
  border-color: var(--primary-color);
  background: var(--primary-color);
  color: #fff;
}

.button:disabled {
  opacity: 0.45;
  cursor: default;
}

.toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.search-field {
  position: relative;
  display: flex;
  align-items: center;
  width: 260px;
}

.search-field > span {
  position: absolute;
  inset-inline-start: 10px;
  color: #8a98ab;
  font-size: 18px;
}

.search-field input {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #dce5ef;
  border-radius: 7px;
  padding: 0 34px;
  color: #253750;
  font: inherit;
  font-size: 11px;
}

.search-field input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.search-field button {
  position: absolute;
  inset-inline-end: 3px;
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #8491a3;
  cursor: pointer;
}

.search-field button span {
  font-size: 17px;
}

.filter-card {
  display: flex;
  align-items: end;
  gap: 12px;
  margin-bottom: 16px;
  padding: 16px 18px;
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
}

.filter-field {
  min-width: 150px;
  flex: 1;
}

.filter-field label {
  display: block;
  margin: 0 0 6px;
  color: #53647a;
  font-size: 11px;
  font-weight: 500;
}

.filter-field mat-form-field {
  width: 100%;
  font-size: 11px;
  --mat-form-field-container-height: 36px;
  --mat-form-field-container-vertical-padding: 8px;
  --mdc-outlined-text-field-outline-color: #dce5ef;
  --mdc-outlined-text-field-focus-outline-color: var(--primary-color) ;
}

.table-card {
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.table-scroll {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: start;
  font-size: 11px;
}

th {
  padding: 12px 16px;
  background: #fbfcfe;
  color: #7d8a9d;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
}

td {
  padding: 12px 16px;
  border-top: 1px solid #edf1f6;
  color: #53647a;
  line-height: 18px;
  vertical-align: middle;
}

tbody tr:hover {
  background: #fcfdff;
}

.record-id {
  color: var(--primary-color);
  font-weight: 500;
}

.sort-button {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.sort-button:hover {
  color: var(--primary-color);
}

.sort-button span {
  font-size: 15px;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  padding: 3px 7px;
  background: #f1f3f7;
  color: #7d8a9d;
  white-space: nowrap;
}

.status > span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
}

.btn-green {
  background: #eef7f2;
  color: #36866a;
}

.btn-black {
  background: #eef1f5;
  color: #53647a;
}

.btn-orange {
  background: #fff7e6;
  color: #936300;
}

.btn-red {
  background: #fff0f0;
  color: #c34242;
}

.btn-grey {
  background: #f1f3f7;
  color: #7d8a9d;
}

.btn-blue {
  background: #edf5ff;
  color: var(--primary-color);
}

.state-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 150px;
  color: #8491a3;
}

.state-message .material-symbols-outlined {
  font-size: 24px;
}

.pagination-bar {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 10px 16px;
  border-top: 1px solid #edf1f6;
  color: #7d8a9d;
}

.pagination-bar mat-form-field {
  width: 58px;
  font-size: 11px;
  --mat-form-field-container-height: 34px;
  --mat-form-field-container-vertical-padding: 7px ;
}

.paginator {
  margin-inline-start: auto;
  font-size: 11px;
}

@media (max-width: 800px) {
  .page-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .filter-card {
    align-items: stretch;
    flex-direction: column;
  }
  .filter-actions {
    justify-content: flex-end;
  }
  .toolbar {
    justify-content: stretch;
  }
  .search-field {
    width: 100%;
  }
}
@media (max-width: 550px) {
  .page-header h1 {
    font-size: 20px;
  }
  .header-actions {
    width: 100%;
    flex-wrap: wrap;
  }
  .pagination-bar {
    flex-wrap: wrap;
  }
  .paginator {
    width: 100%;
    margin-inline-start: 0;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-transaction-list/my-transaction-list.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;;EAEI,aAAA;EACA,mBAAA;EACA,QAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;;EAEI,iEAAA;EACA,8DAAA;EACA,2BAAA;AACJ;;AAEA;EACI,kCAAA;EACA,gCAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,kCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,OAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;EACA,oEAAA;AACJ;;AAEA;EACI,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,uCAAA;EACA,iDAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;AACJ;;AAEA;EACI;IACI,uBAAA;IACA,sBAAA;EACN;EAEE;IACI,oBAAA;IACA,sBAAA;EAAN;EAGE;IACI,yBAAA;EADN;EAIE;IACI,wBAAA;EAFN;EAKE;IACI,WAAA;EAHN;AACF;AAMA;EACI;IACI,eAAA;EAJN;EAOE;IACI,WAAA;IACA,eAAA;EALN;EAQE;IACI,eAAA;EANN;EASE;IACI,WAAA;IACA,sBAAA;IACA,kBAAA;EAPN;AACF","sourcesContent":[":host {\n    display: block;\n    color: #253750;\n    font-size: 12px\n}\n\n.transactions-page {\n    padding: 2px 0 8px\n}\n\n.page-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 18px;\n    margin-bottom: 18px\n}\n\n.page-header h1 {\n    margin: 0;\n    color: #172b46;\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 30px\n}\n\n.page-header p {\n    margin: 6px 0 0;\n    color: #7d8a9d;\n    font-size: 12px\n}\n\n.header-actions,\n.filter-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px\n}\n\n.button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    min-height: 35px;\n    border: 1px solid #dce5ef;\n    border-radius: 8px;\n    padding: 7px 12px;\n    background: #fff;\n    color: #53647a;\n    font: inherit;\n    font-size: 12px;\n    cursor: pointer\n}\n\n.button .material-symbols-outlined {\n    font-size: 18px\n}\n\n.button:hover,\n.button.selected {\n    border-color: color-mix(in srgb, var(--primary-color) 25%, white);\n    background: color-mix(in srgb, var(--primary-color) 5%, white);\n    color: var(--primary-color)\n}\n\n.button.primary {\n    border-color: var(--primary-color);\n    background: var(--primary-color);\n    color: #fff\n}\n\n.button:disabled {\n    opacity: .45;\n    cursor: default\n}\n\n.toolbar {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 12px\n}\n\n.search-field {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 260px\n}\n\n.search-field>span {\n    position: absolute;\n    inset-inline-start: 10px;\n    color: #8a98ab;\n    font-size: 18px\n}\n\n.search-field input {\n    width: 100%;\n    height: 36px;\n    box-sizing: border-box;\n    border: 1px solid #dce5ef;\n    border-radius: 7px;\n    padding: 0 34px;\n    color: #253750;\n    font: inherit;\n    font-size: 11px\n}\n\n.search-field input:focus {\n    outline: none;\n    border-color: var(--primary-color)\n}\n\n.search-field button {\n    position: absolute;\n    inset-inline-end: 3px;\n    display: grid;\n    place-items: center;\n    width: 30px;\n    height: 30px;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: #8491a3;\n    cursor: pointer\n}\n\n.search-field button span {\n    font-size: 17px\n}\n\n.filter-card {\n    display: flex;\n    align-items: end;\n    gap: 12px;\n    margin-bottom: 16px;\n    padding: 16px 18px;\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: #fff\n}\n\n.filter-field {\n    min-width: 150px;\n    flex: 1\n}\n\n.filter-field label {\n    display: block;\n    margin: 0 0 6px;\n    color: #53647a;\n    font-size: 11px;\n    font-weight: 500\n}\n\n.filter-field mat-form-field {\n    width: 100%;\n    font-size: 11px;\n    --mat-form-field-container-height: 36px;\n    --mat-form-field-container-vertical-padding: 8px;\n    --mdc-outlined-text-field-outline-color: #dce5ef;\n    --mdc-outlined-text-field-focus-outline-color: var(--primary-color)\n}\n\n.table-card {\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: #fff;\n    overflow: hidden\n}\n\n.table-scroll {\n    overflow-x: auto\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: start;\n    font-size: 11px\n}\n\nth {\n    padding: 12px 16px;\n    background: #fbfcfe;\n    color: #7d8a9d;\n    font-size: 10px;\n    font-weight: 500;\n    white-space: nowrap\n}\n\ntd {\n    padding: 12px 16px;\n    border-top: 1px solid #edf1f6;\n    color: #53647a;\n    line-height: 18px;\n    vertical-align: middle\n}\n\ntbody tr:hover {\n    background: #fcfdff\n}\n\n.record-id {\n    color: var(--primary-color);\n    font-weight: 500\n}\n\n.sort-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    cursor: pointer\n}\n\n.sort-button:hover {\n    color: var(--primary-color)\n}\n\n.sort-button span {\n    font-size: 15px\n}\n\n.status {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    border-radius: 20px;\n    padding: 3px 7px;\n    background: #f1f3f7;\n    color: #7d8a9d;\n    white-space: nowrap\n}\n\n.status>span {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: currentColor\n}\n\n.btn-green {\n    background: #eef7f2;\n    color: #36866a\n}\n\n.btn-black {\n    background: #eef1f5;\n    color: #53647a\n}\n\n.btn-orange {\n    background: #fff7e6;\n    color: #936300\n}\n\n.btn-red {\n    background: #fff0f0;\n    color: #c34242\n}\n\n.btn-grey {\n    background: #f1f3f7;\n    color: #7d8a9d\n}\n\n.btn-blue {\n    background: #edf5ff;\n    color: var(--primary-color)\n}\n\n.state-message {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    min-height: 150px;\n    color: #8491a3\n}\n\n.state-message .material-symbols-outlined {\n    font-size: 24px\n}\n\n.pagination-bar {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    padding: 10px 16px;\n    border-top: 1px solid #edf1f6;\n    color: #7d8a9d\n}\n\n.pagination-bar mat-form-field {\n    width: 58px;\n    font-size: 11px;\n    --mat-form-field-container-height: 34px;\n    --mat-form-field-container-vertical-padding: 7px\n}\n\n.paginator {\n    margin-inline-start: auto;\n    font-size: 11px\n}\n\n@media(max-width:800px) {\n    .page-header {\n        align-items: flex-start;\n        flex-direction: column\n    }\n\n    .filter-card {\n        align-items: stretch;\n        flex-direction: column\n    }\n\n    .filter-actions {\n        justify-content: flex-end\n    }\n\n    .toolbar {\n        justify-content: stretch\n    }\n\n    .search-field {\n        width: 100%\n    }\n}\n\n@media(max-width:550px) {\n    .page-header h1 {\n        font-size: 20px\n    }\n\n    .header-actions {\n        width: 100%;\n        flex-wrap: wrap\n    }\n\n    .pagination-bar {\n        flex-wrap: wrap\n    }\n\n    .paginator {\n        width: 100%;\n        margin-inline-start: 0;\n        text-align: center\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
